<script setup lang="ts">
import type { JournalEntry, JournalOperation } from '@/models/api-generated'
import { formatDateTime } from '@/services/utils'
import { formatValue } from './format'
import { computed, onMounted, ref } from 'vue'

const props = defineProps<{
	showName?: boolean
}>()

const model = defineModel<JournalOperation>({ required: true })
const name = defineModel('')
const formatted = ref<JournalEntry[]>([])

onMounted(async () => {
	if (props.showName) name.value = await formatValue(model.value.table, 'id', model.value.rowId.toString())

	formatted.value = await Promise.all(
		model.value.entries
			.filter((x) => x.field)
			.map(async (x) => {
				return {
					field: x.field,
					oldValue: await formatValue(model.value.table, x.field, x.oldValue),
					newValue: await formatValue(model.value.table, x.field, x.newValue),
				}
			}),
	)
})
</script>

<template>
	<div class="card my-1">
		<div class="card-body">
			<div class="card-title">
				<b>{{ model.user.firstname }} {{ model.user.lastname }}</b>
				<br />
				<i>{{ $t(`journal.verbs.${model.verb}`) }}</i> {{ $t('journal.intable') }} <b>{{ $t(`journal.tables.${model.table}`) }}</b>
				<br />
				<template v-if="name">
					<b>{{ name }}</b>
					<br />
				</template>
				<b>{{ formatDateTime(model.createdAt) }}</b>
			</div>

			<table v-if="formatted.length" class="table striped w-100">
				<tr>
					<th>{{ $t('journal.field') }}</th>
					<th v-if="model.verb === 'UPDATE' || model.verb === 'DELETE'">{{ $t('journal.oldValue') }}</th>
					<th v-if="model.verb === 'INSERT' || model.verb === 'UPDATE'">{{ $t('journal.newValue') }}</th>
				</tr>

				<template v-for="(entry, i) in model.entries" :key="i">
					<tr v-if="$te(`journal.fields.${model.table}.${entry.field}`)">
						<td>{{ $t(`journal.fields.${model.table}.${entry.field}`) }}</td>
						<td v-if="model.verb === 'UPDATE' || model.verb === 'DELETE'">{{ formatted[i].oldValue }}</td>
						<td v-if="model.verb === 'INSERT' || model.verb === 'UPDATE'">{{ formatted[i].newValue }}</td>
					</tr>
				</template>
			</table>
		</div>
	</div>
</template>
